import { Flex, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

interface StatusDisplayProps {
  currentCustomStatus:
    | {
        availability: string
        label: string
      }
    | undefined
  formattedTime: string | undefined
}

export const StatusDisplay = ({
  currentCustomStatus,
  formattedTime,
}: StatusDisplayProps) => {
  const { t } = useTranslation()
  if (!currentCustomStatus || currentCustomStatus.availability !== 'Away') {
    return null
  }

  return (
    <Flex
      w={'full'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      gap={'0.5rem'}
      borderRadius={'0.5rem'}
      border={'1px solid var(--chakra-colors-border-subtle)'}
      bg="bg.panel"
      margin={'0.25rem'}
    >
      <Text
        color={'var(--chakra-colors-fg-default)'}
        fontWeight={300}
        fontSize={{ base: '5rem', md: '8rem', lg: '10rem' }}
        lineHeight={{ base: '5rem', md: '8rem', lg: '10rem' }}
        width={{ base: '20rem', md: '40rem', lg: '50rem' }}
        textAlign={'center'}
        css={{ fontVariantNumeric: 'tabular-nums' }}
      >
        {formattedTime}
      </Text>
      <Text
        color={'var(--chakra-colors-fg-default)'}
        fontWeight={800}
        fontSize={'2rem'}
        lineHeight={'2.5rem'}
      >
        {t('webPhoneExtras.awayWithLabel', 'Away - {{label}}', {
          label: currentCustomStatus.label,
        })}
      </Text>
    </Flex>
  )
}
